var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBrowserEdge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "74px",
    viewBox: "0 0 74 74",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_browser_edge") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-7.97051215e-15%",
    y1: "50.0129955%",
    x2: "100.026435%",
    y2: "50.0129955%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C59A4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "55.2461807%",
    cy: "50.9262508%",
    fx: "55.2461807%",
    fy: "50.9262508%",
    r: "62.4122927%",
    gradientTransform: "translate(0.552462,0.509263),scale(0.857143,1.000000),translate(-0.552462,-0.509263)",
    id: "radialGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "72%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.53,
    offset: "95%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "76.7404324%",
    y1: "24.7942842%",
    x2: "33.1855142%",
    y2: "83.1510351%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9DE2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1595DF",
    offset: "16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0680D7",
    offset: "67%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078D4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "41.8348485%",
    cy: "72.5639478%",
    fx: "41.8348485%",
    fy: "72.5639478%",
    r: "84.9918011%",
    gradientTransform: "translate(0.418348,0.725639),scale(1.000000,0.811688),rotate(-81.371078),translate(-0.418348,-0.725639)",
    id: "radialGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "76%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.5,
    offset: "95%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "10.1019077%",
    cy: "27.7890034%",
    fx: "10.1019077%",
    fy: "27.7890034%",
    r: "118.831665%",
    gradientTransform: "translate(0.101019,0.277890),scale(0.663158,1.000000),rotate(92.300159),translate(-0.101019,-0.277890)",
    id: "radialGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C1F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34C1ED",
    offset: "11%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FC2DF",
    offset: "23%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BC3D2",
    offset: "31%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36C752",
    offset: "67%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "93.7723426%",
    cy: "45.4027789%",
    fx: "93.7723426%",
    fy: "45.4027789%",
    r: "57.1137844%",
    gradientTransform: "translate(0.937723,0.454028),scale(0.663158,1.000000),rotate(73.675542),translate(-0.937723,-0.454028)",
    id: "radialGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66EB6E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66EB6E",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_browser_edge",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "microsoft-edge-new-2020-seeklogo.com-2-2-copy",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "microsoft-edge-new-2020-seeklogo.com-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.8207679,54.7239376 C65.8291148,55.2389311 64.8064355,55.6927351 63.7585478,56.082768 C60.4230687,57.3220724 56.8897228,57.9534262 53.3284054,57.9464717 C39.5803737,57.9464717 27.6045946,48.5558285 27.6045946,36.5052242 C27.6404335,33.2140329 29.4666929,30.1996725 32.3780553,28.6263158 C19.9432338,29.145614 16.7473684,42.0126706 16.7473684,49.5511501 C16.7473684,70.8654581 36.529775,73.0263158 40.7918972,73.0263158 C43.0900149,73.0263158 46.5560762,72.362768 48.636294,71.7107602 L49.0168925,71.5838207 C57.0217919,68.8358407 63.8460215,63.4635206 68.3664046,56.3510721 C68.6512258,55.9054659 68.595307,55.3247691 68.2306045,54.9408366 C67.8659019,54.5569041 67.2853694,54.467591 66.8207679,54.7239376 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8207679,54.7239376 C65.8291148,55.2389311 64.8064355,55.6927351 63.7585478,56.082768 C60.4230687,57.3220724 56.8897228,57.9534262 53.3284054,57.9464717 C39.5803737,57.9464717 27.6045946,48.5558285 27.6045946,36.5052242 C27.6404335,33.2140329 29.4666929,30.1996725 32.3780553,28.6263158 C19.9432338,29.145614 16.7473684,42.0126706 16.7473684,49.5511501 C16.7473684,70.8654581 36.529775,73.0263158 40.7918972,73.0263158 C43.0900149,73.0263158 46.5560762,72.362768 48.636294,71.7107602 L49.0168925,71.5838207 C57.0217919,68.8358407 63.8460215,63.4635206 68.3664046,56.3510721 C68.6512258,55.9054659 68.595307,55.3247691 68.2306045,54.9408366 C67.8659019,54.5569041 67.2853694,54.467591 66.8207679,54.7239376 Z",
    id: "Path",
    fill: "url(#radialGradient-2)",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5188506,69.5845051 C27.9417307,67.9874642 25.708314,65.8948223 23.9484628,63.4282564 C19.8882118,57.8741288 18.4941184,50.8122754 20.1397942,44.135246 C21.78547,37.4582166 26.3026404,31.8487549 32.480721,28.8101752 C33.3821991,28.3861037 34.922224,27.6187363 36.970775,27.6562392 C39.8965355,27.6775082 42.6435232,29.0654049 44.3935219,31.4065313 C45.5603093,32.9619884 46.2036207,34.8464921 46.2311502,36.7896429 C46.2311502,36.7290613 53.2985067,13.8263158 23.1163292,13.8263158 C10.4320712,13.8263158 0.00150827574,25.8445596 0.00150827574,36.3886502 C-0.0485239573,41.9663342 1.1467706,47.4850754 3.5005143,52.5437547 C11.4628907,69.5060797 30.8848632,77.8279427 48.6842105,71.9039166 C42.5908474,73.8221173 35.9616794,72.9786876 30.5448548,69.5960445 L30.5188506,69.5845051 Z",
    id: "Path",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5188506,69.5845051 C27.9417307,67.9874642 25.708314,65.8948223 23.9484628,63.4282564 C19.8882118,57.8741288 18.4941184,50.8122754 20.1397942,44.135246 C21.78547,37.4582166 26.3026404,31.8487549 32.480721,28.8101752 C33.3821991,28.3861037 34.922224,27.6187363 36.970775,27.6562392 C39.8965355,27.6775082 42.6435232,29.0654049 44.3935219,31.4065313 C45.5603093,32.9619884 46.2036207,34.8464921 46.2311502,36.7896429 C46.2311502,36.7290613 53.2985067,13.8263158 23.1163292,13.8263158 C10.4320712,13.8263158 0.00150827574,25.8445596 0.00150827574,36.3886502 C-0.0485239573,41.9663342 1.1467706,47.4850754 3.5005143,52.5437547 C11.4628907,69.5060797 30.8848632,77.8279427 48.6842105,71.9039166 C42.5908474,73.8221173 35.9616794,72.9786876 30.5448548,69.5960445 L30.5188506,69.5845051 Z",
    id: "Path",
    fill: "url(#radialGradient-4)",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0301389,43.0430695 C43.7960129,43.3453048 43.0762922,43.7626774 43.0762922,44.6722618 C43.0762922,45.4235324 43.5676678,46.1460187 44.440582,46.7533678 C48.5970409,49.6317994 56.4330356,49.2518464 56.4532687,49.2518464 C59.5331118,49.2444856 62.5545798,48.4144755 65.2026438,46.8483561 C70.6383221,43.6876735 73.9853701,37.8954844 73.9982659,31.6272098 C74.0734175,25.1766446 71.6859104,20.8877815 70.720502,18.9880167 C64.5956504,7.05691775 51.374758,0.194736842 36.9976877,0.194736842 C16.7658985,0.192744601 0.284509438,16.3748303 0,36.5205435 C0.138741329,26.0027545 10.6368352,17.5085029 23.1235548,17.5085029 C24.1352104,17.5085029 29.9045373,17.6063695 35.2634211,20.4070835 C39.9864072,22.8767778 42.4606276,25.8588329 44.180442,28.8149821 C45.9667366,31.8862687 46.2846855,35.7663944 46.2846855,37.3121122 C46.2846855,38.85783 45.4927037,41.1490615 44.0301389,43.0430695 Z",
    id: "Path",
    fill: "url(#radialGradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0301389,43.0430695 C43.7960129,43.3453048 43.0762922,43.7626774 43.0762922,44.6722618 C43.0762922,45.4235324 43.5676678,46.1460187 44.440582,46.7533678 C48.5970409,49.6317994 56.4330356,49.2518464 56.4532687,49.2518464 C59.5331118,49.2444856 62.5545798,48.4144755 65.2026438,46.8483561 C70.6383221,43.6876735 73.9853701,37.8954844 73.9982659,31.6272098 C74.0734175,25.1766446 71.6859104,20.8877815 70.720502,18.9880167 C64.5956504,7.05691775 51.374758,0.194736842 36.9976877,0.194736842 C16.7658985,0.192744601 0.284509438,16.3748303 0,36.5205435 C0.138741329,26.0027545 10.6368352,17.5085029 23.1235548,17.5085029 C24.1352104,17.5085029 29.9045373,17.6063695 35.2634211,20.4070835 C39.9864072,22.8767778 42.4606276,25.8588329 44.180442,28.8149821 C45.9667366,31.8862687 46.2846855,35.7663944 46.2846855,37.3121122 C46.2846855,38.85783 45.4927037,41.1490615 44.0301389,43.0430695 Z",
    id: "Path",
    fill: "url(#radialGradient-6)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBrowserEdge);
export default __webpack_public_path__ + "static/media/icon_browser_edge.52f41f0be068fc24f681bad2cf0b80e4.svg";
export { ForwardRef as ReactComponent };